/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { Injectable } from "@angular/core";
import type { ItemsService } from "@app/@classes/abstract/items-service-interface";
import { ItemsViewServiceBase } from "@app/@classes/abstract/items-view-service";
import type { Views } from "@app/@classes/supabase";

const VIEW = "users_in_tenant";
type T = typeof VIEW;

@Injectable({
  providedIn: "root",
})
export class UsersInTenantService
  extends ItemsViewServiceBase<Views<T>>
  implements ItemsService<Views<T>> {
  constructor() {
    super(VIEW, { hasTenant: false });
  }

  override defaultItem(): Views<T> {
    return {
      id: this.randomUUID(),
      user_id: "",
      avatar_type: null,
      created_at: null,
      email: "",
      name: "",
      custom_initials: "",
      profile_img: "",
      role: null,
      tenant_id: "",
      updated_at: null,
      invitation_email: null,
      invitation_status: null,
      invitation_token: null,
      invited_by_user_id: null,
    };
  }
}
